export default __webpack_public_path__ + "static/media/ms-symbollockup_signup_light.719ac733.svg";